import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { requestReducer } from './Store/request.reducer';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { routes } from './app.routes';
import { provideChatbot } from '@dbug3/chatbot-angular';
import { environment } from '../environments/environment';

import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    provideAnimations(),

    provideHttpClient(withInterceptorsFromDi()),

    provideStore({
      request: requestReducer
    }),

    provideCharts(withDefaultRegisterables()),

    provideChatbot({
      apiBaseUrl: environment.chatbotApiUrl,
      getAuthToken: () => localStorage.getItem('token') ?? '',
      welcomeMessage: "I've been trained on extreme weather event research to assist you. Right now you can ask me to help with:",
      suggestions: [
        'assessing extreme weather risk to a specific client and developing insight to share with your client',
        'analysing risks across your entire client portfolio or for a particular City, State or Region',
        'Refining payout structures, attachment and exhaustion points when drafting a non-binding indication for a client'
      ]
    }),

    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: { disabled: true }
    }
  ]
};